import {createStrokeSVG} from './TEMPLATE'

// lucide: grip-vertical
export const DotGrid2x3_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M8 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0Z',
    'M8 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0Z',
    'M8 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0Z',
    'M14 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0Z',
    'M14 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0Z',
    'M14 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0Z',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// lucide: ellipsis
export const DotGrid3x1_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0Z',
    'M18 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0Z',
    'M4 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0Z',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
